module.exports = __webpack_public_path__ + "img/profile-user-red.7f3b75f9.svg";